<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { Icon } from '@components'
import { sortedDays, toRGB } from '@utils'
import moment from 'moment'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

// emit
const emit = defineEmits(['update:modelValue', 'change'])

// props
const props = defineProps({
    futureDays: {
        type: Number,
        default: 90
    }
})

const activeDate = ref({})

// original days array according to [new Date()]
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',]

const activeCalender = ref({
    month: 1, // specify the month (1 for January, 2 for February, etc.)
    year: 0, // specify the year
    dates: [],
})

const generateDates = () => {
    const selectedDate = moment($appointments.selectedDate.fullDate, 'YYYY-MM-DD')
    const startDayOfCalenderWeek = sortedDays()[0]

    activeCalender.value.dates = []

    let dayToAddStart = (selectedDate.day() + 7 - days.indexOf(startDayOfCalenderWeek)) % 7
    let dateStart = selectedDate.subtract(dayToAddStart, 'days')

    for (let i = 0; i < 7; i++) {
        activeCalender.value.dates.push({
            day: dateStart.format('dddd'),
            date: dateStart.date(),
            month: dateStart.format('MMMM'),
            year: dateStart.format('YYYY'),
            fullDate: dateStart.format('YYYY-MM-DD'),
        })

        dateStart.add(1, 'days')
    }

}


onMounted(() => {
    if (!$appointments.selectedDate) {
        // set the current month and year
        activeCalender.value.month = moment().format('MM')
        activeCalender.value.year = moment().format('YYYY')
    } else {
        // if date is selected then set the active date
        activeCalender.value.year = moment($appointments.selectedDate.fullDate, 'YYYY-MM-DD').format('YYYY')
        activeCalender.value.month = moment($appointments.selectedDate.fullDate, 'YYYY-MM-DD').format('MM')
        activeDate.value = $appointments.selectedDate
    }
})


const getDates = computed(() => {
    generateDates()
    return activeCalender.value.dates
})

// const isFuture = (fullDate) => {
//     const startDate = moment().format('YYYY-MM-DD')
//     const endDate = moment(fullDate, 'YYYY-MM-DD')

//     const differenceInDays = endDate.diff(startDate, 'days')

//     if (differenceInDays > props.futureDays) {
//         return true
//     } else {
//         return false
//     }
// }

const selectDate = (item) => {
    if (!item) return
    if (isDisabled(item)) return
    if (item.fullDate == "") return

    activeDate.value = item

    emit('update:modelValue', activeDate.value)
    emit('change', activeDate.value)

    // $appointments.setAppointment('booking_date', $appointments.appointment.booking_date, false)
}

const isActive = (item) => {
    if (!item) return
    return item.fullDate == activeDate.value.fullDate
}

const isDisabled = (item) => {
    // Check if the date is in availableDates.
    const availableDates = $appointments.availableDates
    if (moment(item.month, 'MMMM').isSame(moment(activeCalender.value.month, 'MM'), 'month') == false) return true
    if (availableDates.length > 0) {
        const findDate = availableDates.find(date => moment(item.fullDate, 'YYYY-MM-DD').isSame(moment(date.date, 'YYYY-MM-DD'), 'day'))
        if (!findDate) return true
    }
}

const progressHeight = (item) => {
    let findDate = $appointments.availableDates.find(date => item.fullDate == date.date)

    if (findDate) return Math.round((findDate.booked / findDate.total) * 100)
    else return 0
}

watch(() => $appointments.selectedDate, () => {
    if ($appointments.selectedDate) {
        activeDate.value = $appointments.selectedDate
    }
})
</script>

<template>
    <div class="mini-calendar-wrapper">
        <!-- calendar header  -->
        <div class="mini-calendar-header">
            <div class="mini-calendar-month">{{ moment(`${activeCalender.year}-${activeCalender.month}-01`, 'YYYY-MM').format('MMMM YYYY') || 'N/A' }}</div>
            <Icon name="calendar" size="20px" class="text-[#667085] m-2 cursor-pointer hover:text-[#222]" @click="$router.push({ name: 'date' })" />
        </div>

        <!-- divider  -->
        <div class="mini-calendar-divider"></div>

        <div class="flex items-end gap-2">
            <!-- <Icon @click="changeDatesArrow('prev')" name="chevronLeft" size="20px" class="text-[#667085] m-2 cursor-pointer hover:text-[#222]" /> -->

            <div class="w-full">

                <!-- calendar days  -->
                <div class="mini-calendar-days-wrapper">
                    <div v-for="day in sortedDays()" :key="day" class="mini-calendar-day" :class="{ 'mini-calendar-day-disabled': isDisabled(day) }">{{ day.slice(0, 3) }}</div>
                </div>

                <!-- calendar dates  -->
                <div class="mini-calendar-dates-wrapper">
                    <div v-for="item in getDates" :key="item" @click="selectDate(item)" class="mini-calendar-date" :class="[isDisabled(item) ? 'mini-calendar-date-disabled' : 'mini-calendar-date-not-disabled '], { 'mini-calendar-date-active': isActive(item) }" :style="`width:${$settings.isWidget ? '32px' : ''};background-color: ${isActive(item) ? `${$settings.customizer.design.brand_color} !important` : ''}; border: 1px solid ${isActive(item) ? `${$settings.customizer.design.brand_color}` : ''} !important; border-color: ${isDisabled(item) ? 'transparent' : `${toRGB($settings.customizer.design.brand_color, 0.3)}`} !important;  border-radius: ${$customizer.isRounded ? '' : '0px'} !important;`">
                        <div v-if="!isActive(item)" class="mini-calendar-bg-pogress" :style="`height:${progressHeight(item)}%; background-color:${$settings.customizer.date.progress_color}`"></div>
                        <div class="mini-calendar-text">{{ item.date }}</div>
                    </div>
                </div>

            </div>

            <!-- <Icon @click="changeDatesArrow('next')" name="chevronRight" size="20px" class="text-[#667085] m-2 cursor-pointer hover:text-[#222]" /> -->
        </div>
    </div>
</template>